import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TaskStatusType} from "../../../../tasks/types/taskStatus.type";

require('./task-status.scss');
@Component({
  standalone: false,
  selector: 'app-task-status',
  templateUrl: './task-status.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskStatusComponent {

  @Input() status: TaskStatusType;
  @Input() small: boolean;

  constructor() {
  }

}
